export const COPY_BLOCK = 'copy-block';
export const CUT_BLOCK = 'cut-block';
export const PASTE_BLOCK = 'paste-block';
export const PASTE_BEFORE_THIS_BLOCK = 'paste-before-this-block';
export const PASTE_AFTER_THIS_BLOCK = 'paste-after-this-block';
